export default "__VITE_ASSET__DMTNUxMV__"